export default function Folder({
  color = 'var(--cobalt)',
  label = 'DJ_XL',
  active = false,
  onClick,
  rotation = 0,
  current = false,
  image,
}) {
  const fillColor = current ? 'var(--sun)' : (active ? 'var(--cobalt-glow)' : color);

  return (
    <button
      type="button"
      className={`v3-folder ${active ? 'is-active' : ''} ${current ? 'is-current' : ''}`}
      onClick={onClick}
      style={{
        transform: `rotate(${rotation}deg)`,
        '--folder-color': fillColor,
      }}
    >
      {image && (
        <img
          className="v3-folder__image"
          src={image}
          alt=""
          draggable={false}
        />
      )}
      <div className="v3-folder__tab" />
      <div className="v3-folder__body">
        <span className="v3-folder__label">{label}</span>
        {current && <span className="v3-folder__badge">[ ! ]</span>}
      </div>
    </button>
  );
}
